declare const __BUILD_TIME__: string | undefined

const BUILD_TIME = typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : undefined

export function buildTime(): Date {
  return BUILD_TIME ? new Date(BUILD_TIME) : new Date()
}
